import { Transcript } from "@brivity/ai-components";
import AiProvider from "./AiProvider";

const AiCallSummary = ({ callSid, isCallRecordingEnabled }) => (
  <AiProvider>
    <Transcript callSID={callSid} isCallRecordingEnabled={isCallRecordingEnabled} />
  </AiProvider>
);

export default AiCallSummary;
